import React from 'react';
import styles from './SecurityPosturePanel.module.css';

interface SecurityPosturePanelProps {
  secured: number;
  warnings: number;
  good: number;
}

export const SecurityPosturePanel: React.FC<SecurityPosturePanelProps> = ({
  secured,
  warnings,
  good,
}) => {
  const circumference = 2 * Math.PI * 45;
  const offset = circumference - (secured / 100) * circumference;

  return (
    <div className={styles.securityPanel}>
      <h3 className={styles.title}>Security Posture</h3>
      <div className={styles.content}>
        <div className={styles.chartContainer}>
          <svg className={styles.donutChart} viewBox="0 0 100 100">
            <circle
              className={styles.donutBackground}
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#2d2d2d"
              strokeWidth="8"
            />
            <circle
              className={styles.donutForeground}
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#28a745"
              strokeWidth="8"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform="rotate(-90 50 50)"
            />
          </svg>
          <div className={styles.chartCenter}>
            <div className={styles.label}>Secured</div>
            <div className={styles.percentage}>{secured}%</div>
          </div>
        </div>
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{warnings}</span>
            <div className={styles.statLabelGroup}>
              <span className={styles.statDot} style={{ backgroundColor: '#ffc107' }}></span>
              <span className={styles.statLabel}>Warning</span>
            </div>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{good}</span>
            <div className={styles.statLabelGroup}>
              <span className={styles.statDot} style={{ backgroundColor: '#28a745' }}></span>
              <span className={styles.statLabel}>Good</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

